import { Component, OnInit } from "@angular/core";
import { CommonModule } from "@angular/common";
import { generateClient } from "aws-amplify/api";
import { listMaintenances } from "src/graphql/queries";

@Component({
    selector: "app-alert-info",
    templateUrl: "./alert-info.component.html",
    styleUrls: ["./alert-info.component.scss"],
    standalone: true,
    imports: [CommonModule]
})
export class AlertInfoComponent implements OnInit {
  date: Date = new Date();
  time: string = this.date.toLocaleTimeString("fr-FR", {
    timeZone: "Europe/Paris",
    hour: "2-digit",
    minute: "2-digit",
  });
  alert: boolean = false;
  alertMessage: string = ""; // Property to hold the alert message
  alertStartTime: string = ""; // Property to hold the start date
  alertStartHour: string | null = null; // Property to hold the start hour
  client = generateClient({});

  constructor() {}

  ngOnInit() {
    this.alertCheck();
  }

  async alertCheck() {
    try {
      // API call using graphql
      const result: any = await this.client.graphql({
        query: listMaintenances,
      });

      const maintenanceItems = result?.data?.listMaintenances?.items || [];

      // Reset alert states
      this.alert = false;
      this.alertMessage = "";
      this.alertStartTime = "";
      this.alertStartHour = null;

      // Get the current date and time in ISO 8601 format (Z = UTC)
      const currentDateTime = new Date().toISOString();

      for (const item of maintenanceItems) {
        // Use the provided startTime directly (ISO format)
        const startTime = item.startTime;

        if (item.status) {
          this.alert = true;
          this.alertMessage = item.message;

          // Create a Date object from the startTime string
          const startDate = new Date(startTime);

          // Define options for date and time formatting in "Europe/Paris" time zone
          const dateOptions: Intl.DateTimeFormatOptions = {
            timeZone: "Europe/Paris",
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
          };
          const timeOptions: Intl.DateTimeFormatOptions = {
            timeZone: "Europe/Paris",
            hour: "2-digit",
            minute: "2-digit",
          };

          // Format the date and time separately using Intl.DateTimeFormat
          const formattedDate = new Intl.DateTimeFormat(
            "fr-FR",
            dateOptions
          ).format(startDate);
          const formattedTime = new Intl.DateTimeFormat(
            "fr-FR",
            timeOptions
          ).format(startDate);

          // Set the formatted values to the component's properties
          this.alertStartTime = formattedDate; // Set the date part
          this.alertStartHour = formattedTime; // Set the time part

          break; // Stop loop once an active alert is found
        }
      }
    } catch (err) {
      console.error("Error checking maintenance:", err);
    }
  }
}
